// extracted by mini-css-extract-plugin
export default {"pagination":"_-_-record-it-components-src-pageContentLayout-ManageEntitiesContentLayout-__pagination"};